module.exports = __webpack_public_path__ + "static/img/bim3.1c670d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shouye/bim3.png
// module id = DSxP
// module chunks = 17